import { 
  SET_USER,
  SET_ROOMS,
} from './actions';

export function setUser(user) {
  return { type: SET_USER, payload: user };
}

export function setRooms(rooms) {
  return { type: SET_ROOMS, payload: rooms };
}



// WEBPACK FOOTER //
// ./src/store/actionCreators.js